import {
  BlockFragment,
  Campaign,
  Section,
} from '__generated__/queries-newsletter';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { emptyCampaign } from './ContentPage/utils/emptyTypes';

export const checkDate = (day: Date) => {
  return moment(day).isBefore(moment(), 'day');
};

export const afterFetch = (isDuplicate: boolean) => (item: Campaign) => {
  if (isEmpty(item) || !item) {
    return emptyCampaign();
  }

  const medias = item.medias?.reduce((acc: any, media: any) => {
    // eslint-disable-next-line fp/no-mutating-methods
    acc.push({
      ...media,
      focusPoint: media.focusPoint ? JSON.parse(media.focusPoint) : null,
      iframely: media.iframely.html
        ? media.iframely
        : JSON.parse(media.iframely),
    });
    return acc;
  }, []);

  return {
    ...item,
    medias,
    availableAt: isDuplicate ? null : item.availableAt,
    sections: item.sections.map((section: Section) => ({
      ...section,
      ...(isDuplicate ? { id: uuid(), isCreate: true } : {}),
      blocks: section.blocks.map((block: BlockFragment) => ({
        ...block,
        ...(isDuplicate ? { id: uuid(), isCreate: true } : {}),
        ...(block.media
          ? {
              media: {
                ...block.media,
                iframely: block.media.iframely
                  ? JSON.parse(block.media.iframely)
                  : null,
                focusPoint: block.media.focusPoint
                  ? JSON.parse(block.media.focusPoint)
                  : null,
              },
            }
          : { media: null }),
      })),
    })),
  };
};
